import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import axios from "axios";
import Swal from "sweetalert2";
import Loader from "../../shared/loader";

const Customers = () => {
  const [customerData, setCustomerData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [total, setTotal] = useState(0);

  const searchParam = ["contact_no", "name", "city_name", "state_name"];

  const getCustomers = (page = 1) => {
    setLoading(true);
    axios.post(API_URL.DEALER_USERS_LIST, { page }).then(
      (res) => {
        if (res.data.status === 1) {
          setCustomerData(res.data.data.data);
          setCurrentPage(res.data.data.current_page);
          setLastPage(res.data.data.last_page);
          setTotal(res.data.data.total);
        }
        setLoading(false);
      },
      () => {
        setLoading(false);
        toast.error("Something went wrong..", { autoClose: 3000 });
      }
    );
  };

  const toggleStatus = (row) => {
    const newStatus = row.status === 1 ? 0 : 1;
    const label = newStatus === 1 ? "Approve" : "Block";
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${label.toLowerCase()} this customer`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: newStatus === 1 ? "#3085d6" : "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: `Yes, ${label}!`,
    }).then((result) => {
      if (result.isConfirmed) {
        axios.post(API_URL.DEALER_USERS_APPROVE, { user_id: row.id, status: newStatus }).then(
          (res) => {
            if (res.data.status === 1) {
              setCustomerData(customerData.map((r) => r.id === row.id ? { ...r, status: newStatus } : r));
              toast.success(`Customer ${label.toLowerCase()}d successfully`, { autoClose: 3000 });
            } else {
              toast.error("Something went wrong..", { autoClose: 3000 });
            }
          },
          () => toast.error("Something went wrong..", { autoClose: 3000 })
        );
      }
    });
  };

  const deleteCustomer = (row) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this customer",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setLoading(true);
        axios.post(API_URL.DEALER_USERS_DELETE, { id: row.id }).then(
          (res) => {
            if (res.data.status === 1) {
              setCustomerData(customerData.filter((r) => r.id !== row.id));
              setTotal((t) => t - 1);
              toast.success(row.name + " deleted successfully", { autoClose: 3000 });
            } else {
              toast.error(Array.isArray(res.data.data) ? res.data.data[0] : res.data.data, { autoClose: 4000 });
            }
            setLoading(false);
          },
          () => {
            setLoading(false);
            toast.error("Something went wrong..", { autoClose: 3000 });
          }
        );
      }
    });
  };

  const search = (items) => {
    if (searchValue.length > 0) {
      return items.filter((item) =>
        searchParam.some(
          (key) =>
            item[key] &&
            item[key].toString().toLowerCase().indexOf(searchValue.toLowerCase()) > -1
        )
      );
    }
    return items;
  };

  useEffect(() => {
    getCustomers();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>Customers <small className="me-2">({total})</small></h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center justify-content-end">
            <div className="form-group mb-0 mr-2" style={{ width: 300 }}>
              <input
                type="text"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                className="form-control"
                placeholder="Search"
              />
            </div>
            <Link to="/customers/add" className="btn btn-primary">
              <i className="fa fa-plus-circle me-2" aria-hidden="true"></i> Add Customer
            </Link>
          </div>
        </div>
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body p-0">
              {loading && <Loader />}
              {!loading && (
                <>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Contact</th>
                          <th>Location</th>
                          <th>Pincode</th>
                          <th className="text-center" style={{ width: "260px" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {search(customerData).map((row, key) => (
                          <tr key={key}>
                            <td>{(currentPage - 1) * 30 + key + 1}</td>
                            <td>{row.name}</td>
                            <td>{row.contact_no}</td>
                            <td>{row.city_name}, {row.state_name}</td>
                            <td>{row.pincode}</td>
                            <td className="d-flex justify-content-center gap-2" style={{ width: "260px" }}>
                              <Link
                                to={"/customers/edit/" + row.id}
                                className="btn btn-sm btn-secondary mr-2"
                              >
                                <i className="fa fa-edit me-1"></i> Edit
                              </Link>
                              <button
                                onClick={() => toggleStatus(row)}
                                className={`mr-2 btn btn-sm ${row.status === 1 ? "btn-danger" : "btn-success"}`}
                              >
                                {row.status === 1 ? "Block" : "Approve"}
                              </button>
                              <button
                                onClick={() => deleteCustomer(row)}
                                className="btn btn-sm btn-danger"
                              >
                                <i className="fa fa-trash me-1"></i> Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {lastPage > 1 && (
                    <div className="d-flex justify-content-center align-items-center gap-2 py-3">
                      <button
                        className="btn btn-sm btn-secondary"
                        disabled={currentPage === 1}
                        onClick={() => getCustomers(currentPage - 1)}
                      >
                        Prev
                      </button>
                      <span>Page {currentPage} of {lastPage}</span>
                      <button
                        className="btn btn-sm btn-secondary"
                        disabled={currentPage === lastPage}
                        onClick={() => getCustomers(currentPage + 1)}
                      >
                        Next
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Customers;
